import { Input, Typography } from 'antd';
import React, { useState } from 'react';

import { apiClient } from '../../../../graphql/api/apiClient';
import {
  EmergencyScenarioTableFragment,
  usegetPropertyWithAccessPointsQuery,
} from '../../../../graphql/api/generated';
import { displayErrorMessage, generateWordsFromSearch } from '../../../../utils';

import { EmergencyScenarioAccessPointsForm } from './EmergencyScenarioAccessPointsForm';
import { EmergencyScenarioAccessPointsTable } from './EmergencyScenarioAccessPointsTable';
import { formatAccessPointsWithEmergencyPlan } from './formatAccessPointsWithEmergencyPlan';

interface IEmergencyScenarioAccessPointsManagerProps {
  emergencyScenario: EmergencyScenarioTableFragment;
  readOnly: boolean;
}

export const EmergencyScenarioAccessPointsManager: React.FC<
  IEmergencyScenarioAccessPointsManagerProps
> = (props) => {
  const { emergencyScenario, readOnly } = props;
  const { property } = emergencyScenario;
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [search, setSearch] = useState<string>('');

  const { data, loading } = usegetPropertyWithAccessPointsQuery({
    variables: {
      propertyId: property.propertyId,
    },
    client: apiClient,
    onError: error => displayErrorMessage(error),
  });

  const propertyAccessPoints = data?.property.accessPoints || [];

  const accessPointsWithEmergencyPlan = formatAccessPointsWithEmergencyPlan({
    accessPoints: propertyAccessPoints,
    emergencyScenarioAccessPoints: emergencyScenario.emergencyScenarioAccessPoints,
  });

  const searchWords = search ? generateWordsFromSearch(search.toLowerCase()) : [];

  const filteredAccessPoints = searchWords.length ? accessPointsWithEmergencyPlan.filter(a => {
    return searchWords.every(word => a.name.toLowerCase().includes(word));
  }) : accessPointsWithEmergencyPlan;

  return (
    <>
      <Typography.Paragraph style={{ paddingTop: 5, paddingBottom: 5 }}>
        Property access points without an emergency plan will continue to operate as normal
        when the emergency scenario is activated.
      </Typography.Paragraph>
      <Input.Search
        placeholder='Search by name...'
        defaultValue={search}
        onChange={e => setSearch(e.target.value)}
        onSearch={v => setSearch(v)}
        enterButton
        allowClear
        style={{ marginBottom: 20 }}
      />
      <EmergencyScenarioAccessPointsTable
        accessPoints={filteredAccessPoints}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        loading={loading}
        readOnly={readOnly}
      />
      {!readOnly && (
        <EmergencyScenarioAccessPointsForm
          emergencyScenario={emergencyScenario}
          setSearch={setSearch}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      )}
    </>
  );
};
